import { render, staticRenderFns } from "./StepAccessCars.vue?vue&type=template&id=1a2c960d&"
import script from "./StepAccessCars.vue?vue&type=script&lang=ts&"
export * from "./StepAccessCars.vue?vue&type=script&lang=ts&"
import style0 from "./StepAccessCars.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCol,VForm,VRadio,VRadioGroup,VRow,VScrollYTransition})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2c960d')) {
      api.createRecord('1a2c960d', component.options)
    } else {
      api.reload('1a2c960d', component.options)
    }
    module.hot.accept("./StepAccessCars.vue?vue&type=template&id=1a2c960d&", function () {
      api.rerender('1a2c960d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/access/StepAccessCars.vue"
export default component.exports